import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { finalize } from 'rxjs/operators';
import { OrderStatus } from '../../../core/enum/mysec/order-status.enum';
import { TradingType } from '../../../core/enum/mysec/trading-type.enum';
import { OpenOrderList } from '../../../core/models/mysec/open-order-list';
import { BusinessesService } from '../../../core/services/api/mysec/businesses.service';
import { ErrorService } from '../../../core/services/error.service';
import { BlockUiService } from '../../../shared/services/blockUi/block-ui.service';
import { PopupService } from '../../../shared/services/popup/popup.service';
import { OrderFilter } from './order-filter';
import { OrderFilterService } from './order-filter.service';

@Component({
    selector: 'app-my-orders',
    templateUrl: './my-orders.component.html',
    styleUrls: ['./my-orders.component.scss'],
    standalone: false
})
export class MyOrdersComponent implements OnInit {
  displayColumns: string[] = [
    'Company',
    'TickerCode',
    'Type',
    'Price',
    'ShareQuantity',
    'OrderMatched',
    'OrderId',
    'Time',
    'Status',
    'Action',
  ];
  total: number;
  isLoading: boolean = false;
  params = this.orderFilterService.filter || new OrderFilter();
  openOrderList: OpenOrderList[];
  selectedTab: number = 1;
  filters = ['Name', 'TickerCode'];
  tabs = [
    {
      id: 1,
      value: 'mysec.openOrders',
    },
    {
      id: 2,
      value: 'mysec.orderHistory',
    },
  ];

  TradingType: typeof TradingType = TradingType;
  OrderStatus: typeof OrderStatus = OrderStatus;

  constructor(
    private errorService: ErrorService,
    private businessesService: BusinessesService,
    private orderFilterService: OrderFilterService,
    private popupService: PopupService,
    private blockUiService: BlockUiService,
  ) {}

  ngOnInit() {
    this.getOrderList();
    this.selectTab(this.selectedTab);
  }

  getOrderList(reload?: boolean) {
    if (reload) {
      this.params.currentPage = 1;
    }

    this.isLoading = true;
    this.orderFilterService.filter = this.params;

    this.businessesService
      .getOrderList(this.params)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.openOrderList = data.data;
          this.total = data.total;
        },
        (err) => {
          this.errorService.showError(err);
        },
      );
  }

  getOrderHistoryList(reload?: boolean) {
    if (reload) {
      this.params.currentPage = 1;
    }

    this.isLoading = true;
    this.orderFilterService.filter = this.params;

    this.businessesService
      .getOrderHistoryList(this.params)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.openOrderList = data.data;
          this.total = data.total;
        },
        (err) => {
          this.errorService.showError(err);
        },
      );
  }

  changePage(event?: PageEvent) {
    this.params.currentPage = event.pageIndex + 1;
    this.params.take = event.pageSize;
    this.getList();
  }

  selectTab(tab: number) {
    this.selectedTab = tab;
    this.params = new OrderFilter();
    this.getList();
  }

  getList(reload?: boolean) {
    if (this.selectedTab === 1) {
      this.getOrderList(reload);
    } else {
      this.getOrderHistoryList(reload);
    }
  }

  cancelOrder(mySecOrderId: number) {
    this.blockUiService.open();

    this.businessesService
      .cancelOrder(mySecOrderId)
      .pipe(finalize(() => this.blockUiService.close()))
      .subscribe(
        (data) => {
          this.popupService.success('mysec.orderCancelled').then(() => {
            this.getList();
          });
        },
        (err) => {
          this.errorService.showError(err);
        },
      );
  }

  filterList(filterBy: string) {
    this.params.filterBy = filterBy;
    this.getList(true);
  }
}
